import { Link } from "wouter";
import { useSiteConfig } from "@/hooks/useSiteConfig";

export function Hero() {
  const siteConfig = useSiteConfig();

  return (
    <section
      data-testid="section-hero"
      className="relative h-[80vh] flex items-center justify-center overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1599816685305-586911197fa0?auto=format&fit=crop&q=60&w=800"
          srcSet="https://images.unsplash.com/photo-1599816685305-586911197fa0?auto=format&fit=crop&q=60&w=800 800w, https://images.unsplash.com/photo-1599816685305-586911197fa0?auto=format&fit=crop&q=70&w=1920 1920w"
          sizes="100vw"
          alt="Manchester city skyline at night - Luxury Escorts Manchester"
          className="w-full h-full object-cover opacity-40 grayscale"
          width={1920}
          height={1080}
          fetchPriority="high"
          decoding="async"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0F0F0F] via-transparent to-[#0F0F0F]/50" />
      </div>

      <div className="relative z-10 text-center px-6 max-w-4xl">
        <div>
          <span className="text-[#D4AF37] uppercase tracking-[0.5em] text-[10px] font-bold mb-6 block drop-shadow-sm">
            Premium & Discreet Agency
          </span>
          <h1 className="text-4xl md:text-6xl lg:text-8xl font-light text-white mb-8 leading-[1.1] tracking-tight">
            Manchester{" "}
            <span className="font-serif italic text-transparent bg-clip-text bg-gradient-to-r from-[#F1D279] via-[#D4AF37] to-[#B48F1B]">
              Escorts
            </span>{" "}
            <span className="block text-2xl md:text-3xl lg:text-4xl mt-2 font-light tracking-widest">
              Premium Companion Agency | Incall & Outcall
            </span>
          </h1>
          <p className="text-gray-300 text-sm md:text-base mb-12 max-w-2xl mx-auto leading-relaxed tracking-wide font-light">
            Luxury Escorts Manchester is the premier escort agency in Greater Manchester.
            Verified companions available 24/7 for incall and outcall bookings.
            Total discretion, selfie-verified profiles, and concierge-level care.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
            {siteConfig.primaryCtaMode === "internal_chat" ? (
              <button
                type="button"
                onClick={() => {
                  window.dispatchEvent(new CustomEvent("open-chat"));
                }}
                data-testid="button-whatsapp"
                className="w-full sm:w-auto px-10 py-5 bg-gradient-to-r from-[#D4AF37] via-[#F1D279] to-[#B48F1B] bg-[length:200%_auto] hover:bg-right text-black font-bold uppercase tracking-[0.2em] text-[10px] rounded-full transition-all duration-500 shadow-xl shadow-[#D4AF37]/20 hover:scale-105 active:scale-95"
              >
                {siteConfig.internalChatLabel}
              </button>
            ) : siteConfig.primaryCtaMode === "whatsapp" && siteConfig.whatsappEnabled ? (
              <a
                href={`https://wa.me/${siteConfig.whatsappNumber}`}
                data-testid="button-whatsapp"
                className="w-full sm:w-auto px-10 py-5 bg-gradient-to-r from-[#D4AF37] via-[#F1D279] to-[#B48F1B] bg-[length:200%_auto] hover:bg-right text-black font-bold uppercase tracking-[0.2em] text-[10px] rounded-full transition-all duration-500 shadow-xl shadow-[#D4AF37]/20 hover:scale-105 active:scale-95"
              >
                {siteConfig.whatsappLabel}
              </a>
            ) : siteConfig.primaryCtaMode === "phone" && siteConfig.phoneEnabled ? (
              <a
                href={`tel:${siteConfig.phoneNumber}`}
                data-testid="button-whatsapp"
                className="w-full sm:w-auto px-10 py-5 bg-gradient-to-r from-[#D4AF37] via-[#F1D279] to-[#B48F1B] bg-[length:200%_auto] hover:bg-right text-black font-bold uppercase tracking-[0.2em] text-[10px] rounded-full transition-all duration-500 shadow-xl shadow-[#D4AF37]/20 hover:scale-105 active:scale-95"
              >
                {siteConfig.phoneLabel}
              </a>
            ) : null}
            <Link
              href="/availability"
              data-testid="button-view-available"
              className="w-full sm:w-auto px-10 py-5 border border-white/10 text-white font-bold uppercase tracking-[0.2em] text-[10px] rounded-full hover:bg-white/5 hover:border-white/20 transition-all backdrop-blur-sm"
            >
              View Available Now
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce opacity-30">
        <span className="text-[10px] text-white uppercase tracking-widest">
          Scroll
        </span>
        <div className="w-[1px] h-10 bg-white" />
      </div>
    </section>
  );
}
